import { Group, type Mesh, type Points } from 'three';
import { degToRad } from '@witmetrics/utils/numbers';
import { isInput } from '@/utils/dom';
import { buildToothMaterial } from '@/utils/scans/deltafaceLoader/materials';
import { replaceMeshMaterial } from '@/utils/scans/deltafaceLoader/meshes';
import { HOTKEYS } from './constants';

export const classes = {
  wrapper: 'relative',
  timelineWrapper:
    'w-[350px] h-[75vh] shrink-0 py-4 pl-4 absolute top-[72px] left-0 z-10 group-data-[compact]/tile:top-[50px]',
  timelineCard: 'size-full p-0',
  header:
    'flex justify-start shrink-0 absolute left-0 right-0 top-[72px] z-10 py-4 px-2 gap-2 overflow-x-auto group-data-[compact]/tile:top-[50px] group-data-[compact]/tile:py-2',
  scene: 'grow bg-grey-2 dark:bg-white/[0.05] w-full',
};

export function getHotkey(e: KeyboardEvent) {
  if (e.target && isInput(e)) return null;
  const key = e.key.toLowerCase();
  return HOTKEYS.includes(key) ? key : null;
}

export function buildMeshGroup(meshes: (Mesh | Points)[]) {
  const group = new Group();
  group.add(...meshes);
  group.rotateZ(degToRad(-90));
  group.rotateY(degToRad(-90));
  return group;
}

export function buildCompareTeeth(meshes: Mesh[]) {
  return meshes.map((mesh) =>
    replaceMeshMaterial(
      mesh,
      buildToothMaterial({
        color: 0x008cfc,
        transparent: true,
        opacity: 0.75,
        clearcoat: 0,
      })
    )
  );
}
